import { Home } from "./Home";
import { Shop } from "./Shop";
import { Footer } from "./Footer";
import { Good } from "./Good";

export const LangFa = {
    direction: 'rtl',
    Home: Home,
    Shop: Shop,
    Footer: Footer,
    Good: Good
}